import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { history } from "../store";
import { withNamespaces } from "react-i18next";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {
  FileCheck,
  LockKeyholeOpen,
  CreditCard,
  ServerCog,
  DoorOpen,
} from "lucide-react";

import AppRentalHeader from "../containers/AppRentalHeader";
import { postSale, putUpdateSale } from "../actions/qrsrental";
import { postRedsysGetParams, fetchCustomer, fetchQrByToken } from "../actions/qrs";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const TICKET_KEY = 'vacway_rental_ticket';

class TicketRentalView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      iva: 21,
      importeBase: null,
      importeIva: null,
      total: null,
      date: new Date().toLocaleString(),
      accessCode: "",
      forwardScreen: false,
      downloadingPDF: false,
      descriptionZone: null,
      zoneSelected: null,
      selectedLocker: null,
      lockerAssigned: null,
      lockerPrice: null,
      qrToken: null,
      lockerMatricula: null,
      lockerCustomer: null,
      qrType: null,
      qrMode: null,
      lockerInvoice: null,
      language: null,
      startDate: null,
      endDate: null,
      customerName: null,
      mail: null,
      phoneNumber: null,
      pinAssigned: [],
      Ds_MerchantCode: null,
      Ds_MerchantName: "VACWAY TECH",
      Ds_Url: "https://vacway.com",
      Ds_AuthorisationCode: null,
      Ds_Date: null,
      Ds_Hour: null,
      doorAccess: 0,
      customerSocialName: null,
      customerInvoiceTaxId: null,
      customerInvoiceAddress: null,
    };

    this.generatePDF = this.generatePDF.bind(this);
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);

    const searchParams = new URLSearchParams(this.props.location.search);
    const lockerPrice      = searchParams.get("lockerPrice");
    const zoneSelected     = searchParams.get("zoneSelected");
    const descriptionZone  = searchParams.get("descriptionZone");
    const selectedLocker   = searchParams.get("selectedLocker");
    const lockerAssigned   = searchParams.get("lockerAssigned");
    const prerentCode      = searchParams.get("prerentCode");
    const qrToken          = searchParams.get("qrToken");
    const lockerMatricula  = searchParams.get("lockerMatricula");
    const lockerCustomer   = searchParams.get("lockerCustomer");
    const qrType           = searchParams.get("qrType");
    const language         = searchParams.get("language");
    const qrMode           = searchParams.get("qrMode");
    const startDate        = searchParams.get("startDate");
    const endDate          = searchParams.get("endDate");
    const customerName     = decodeURIComponent(searchParams.get("customerName") || "");
    const mail             = searchParams.get("mail");
    const phoneNumber      = searchParams.get("phoneNumber");
    const idNumber         = searchParams.get("idNumber") || '';
    const paymentId        = searchParams.get("paymentId");
    const dsSignatureVersion    = searchParams.get("Ds_SignatureVersion");
    const dsMerchantParameters  = searchParams.get("Ds_MerchantParameters");
    const dsSignature           = searchParams.get("Ds_Signature");
    const customerId       = searchParams.get("customerId");

    if (qrToken) {
      this.props.fetchQrByToken(qrToken);
    }

    this.props.i18n.changeLanguage(language);

    // ── Reload guard: restore from sessionStorage if ticket already processed ──
    const savedTicket = (() => {
      try { return JSON.parse(sessionStorage.getItem(TICKET_KEY)); } catch { return null; }
    })();

    if (savedTicket && savedTicket.prerentCode === prerentCode) {
      this.setState({
        lockerPrice:      lockerPrice || 0,
        descriptionZone,
        zoneSelected,
        selectedLocker,
        lockerAssigned,
        qrToken,
        lockerMatricula,
        lockerCustomer,
        qrType,
        qrMode,
        lockerInvoice:    prerentCode,
        language,
        startDate,
        endDate,
        customerName,
        mail,
        phoneNumber,
        pinAssigned:      savedTicket.pinAssigned || [],
        doorAccess:       savedTicket.doorAccess  || 0,
        Ds_AuthorisationCode: savedTicket.Ds_AuthorisationCode || null,
        Ds_MerchantCode:      savedTicket.Ds_MerchantCode      || null,
        Ds_Date:              savedTicket.Ds_Date               || null,
        Ds_Hour:              savedTicket.Ds_Hour               || null,
        customerSocialName:       savedTicket.customerSocialName       || null,
        customerInvoiceTaxId:     savedTicket.customerInvoiceTaxId     || null,
        customerInvoiceAddress:   savedTicket.customerInvoiceAddress   || null,
        date: new Date().toLocaleString(),
      }, () => this.TotalComponent());

      // Still fetch customer data for PDF (read-only, safe to repeat)
      if (customerId) {
        this.props.fetchCustomer(customerId)
          .then(customer => {
            if (customer?.response) {
              this.setState({
                customerSocialName:     customer.response.Social_name     || "VACWAY TECH S.L.",
                customerInvoiceTaxId:   customer.response.Invoice_taxid   || "N/A",
                customerInvoiceAddress: customer.response.Invoice_address  || "N/A",
              });
            }
          })
          .catch(console.error);
      }
      return;
    }

    // ── First-time: block on page reload ──
    const navigationEntries = window.performance.getEntriesByType("navigation");
    if (navigationEntries.length > 0 && navigationEntries[0].type === "reload") {
      console.log("Page was reloaded");
      return;
    }

    this.setState(
      {
        lockerPrice:    lockerPrice || 0,
        descriptionZone,
        zoneSelected,
        selectedLocker,
        lockerAssigned,
        qrToken,
        lockerMatricula,
        lockerCustomer,
        qrType,
        qrMode,
        lockerInvoice:  prerentCode,
        language,
        startDate,
        endDate,
        customerName,
        mail,
        phoneNumber,
      },
      () => {
        const saleData = {
          PrerentCode:    this.state.lockerInvoice,
          CustomerName:   this.state.customerName,
          CustomerEmail:  this.state.mail,
          CustomerPhone:  this.state.phoneNumber,
          IdNumber:       idNumber,
          EmailLanguage:  this.state.language === "en" ? "gb" : "es",
          SendEmail:      true,
          SaleQR:         this.state.qrToken,
          auth_code:      null,
          payment_id:     paymentId,
          order_id:       null,
          merchant_id:    null,
          payment_date:   null,
          payment_time:   null,
        };

        const paramsRedsys = {
          Ds_SignatureVersion:    dsSignatureVersion,
          Ds_MerchantParameters:  dsMerchantParameters,
          Ds_Signature:           dsSignature,
          parameterToFetch:       "all",
          secretKey:              null,
        };

        this.props
          .postSale(saleData)
          .then((answer) => {
            const today      = new Date().toLocaleString();
            const pinAssigned = answer.response.PinAssigned || [];
            const doorCode    = answer.response.DoorAccess  || 0;

            this.setState({ date: today, pinAssigned, doorAccess: doorCode });
            this.TotalComponent();

            return this.props.fetchCustomer(customerId);
          })
          .then((customer) => {
            if (!customer?.response?.Redsys) {
              throw new Error("Invalid customer response or missing Redsys data");
            }

            paramsRedsys.secretKey = customer.response.Redsys.SECRETKEY;

            this.setState({
              customerSocialName:     customer.response.Social_name     || "VACWAY TECH S.L.",
              customerInvoiceTaxId:   customer.response.Invoice_taxid   || "N/A",
              customerInvoiceAddress: customer.response.Invoice_address  || "N/A",
            });

            return this.props.postRedsysGetParams(paramsRedsys);
          })
          .then((answer) => {
            console.log("RedsysResponse:", answer);

            const saleUpdateDate = {
              auth_code:    answer.response.decodedParams?.Ds_AuthorisationCode || "N/A",
              order_id:     answer.response.decodedParams?.Ds_Order             || "N/A",
              merchant_id:  answer.response.decodedParams?.Ds_MerchantCode      || "N/A",
              payment_date: answer.response.decodedParams?.Ds_Date              || new Date().toLocaleDateString(),
              payment_time: answer.response.decodedParams?.Ds_Hour              || new Date().toLocaleTimeString(),
            };

            this.props.putUpdateSale(prerentCode, saleUpdateDate);

            this.setState({
              Ds_AuthorisationCode: saleUpdateDate.auth_code,
              Ds_MerchantCode:      saleUpdateDate.merchant_id,
              Ds_Date:              saleUpdateDate.payment_date,
              Ds_Hour:              saleUpdateDate.payment_time,
            }, () => {
              // Persist to sessionStorage so reload restores the ticket without API calls
              try {
                const s = this.state;
                sessionStorage.setItem(TICKET_KEY, JSON.stringify({
                  prerentCode,
                  pinAssigned:           s.pinAssigned,
                  doorAccess:            s.doorAccess,
                  Ds_AuthorisationCode:  s.Ds_AuthorisationCode,
                  Ds_MerchantCode:       s.Ds_MerchantCode,
                  Ds_Date:               s.Ds_Date,
                  Ds_Hour:               s.Ds_Hour,
                  customerSocialName:    s.customerSocialName,
                  customerInvoiceTaxId:  s.customerInvoiceTaxId,
                  customerInvoiceAddress: s.customerInvoiceAddress,
                }));
              } catch { /* ignore */ }
            });
          })
          .catch((error) => {
            console.error("An error occurred:", error);
            this.TotalComponent();
          });
      }
    );
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    sessionStorage.removeItem(TICKET_KEY);
  }

  handleBeforeUnload = (event) => {
    // Set the returnValue property of the event to show the alert message
    event.preventDefault();
  };

  getImageDataURL = (imageUrl) => {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const image = new Image();

      image.onload = () => {
        canvas.width = image.width;
        canvas.height = image.height;
        ctx.drawImage(image, 0, 0);

        const dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };

      image.onerror = (error) => {
        reject(error);
      };

      image.src = imageUrl;
    });
  };

  TotalComponent() {
    const { iva, lockerPrice } = this.state;

    let importeBase = (lockerPrice / (1 + iva / 100)).toFixed(2);
    let importeIva = (lockerPrice - importeBase).toFixed(2);
    let total = Number(lockerPrice).toFixed(2);

    this.setState({
      importeBase: importeBase,
      importeIva: importeIva,
      total: total,
    });

    return { total, importeBase, importeIva, iva };
  }

  getLockerType(type) {
    const { t, i18n } = this.props;

    switch (type) {
      case "BNS":
        return "Standard";
      case "CNS":
        return "Standard Carga";
      case "BWS":
        return "Standard XL";
      case "BNM":
        return "Medium";
      case "CNM":
        return "Medium Carga";
      case "BWM":
        return "Medium XL";
      case "CWM":
        return "Medium Carga XL";
      case "BNL":
        return "Large";
      case "CNL":
        return "Large Carga";
      case "BWL":
        return "Large XL";
      case "CWL":
        return "Large Carga XL";
      case "BNXL":
        return "Large";
      case "CNXL":
        return "Large Carga";
      case "BWXL":
        return "Large XL";
      case "CWXL":
        return "Large Carga XL";
      case "BN2XL":
        return "Large";
      case "CN2XL":
        return "Large Carga";
      case "BW2XL":
        return "Large XL";
      case "CW2XL":
        return "Large Carga XL";
      case "BN3XL":
        return "Ski";
      case "CN3XL":
        return "Ski Carga";
      case "BW3XL":
        return "Ski XL";
      case "BW3XL":
        return "Ski Carga XL";
      default:
        return "None";
    }
  }

  getButtonStyle() {
    const { qrData } = this.props;
    const buttonColor1 = qrData?.headerConfig?.buttonColor1 || '#01315f';
    const buttonColor2 = qrData?.headerConfig?.buttonColor2 || '#067ddb';
    const buttonText = qrData?.headerConfig?.buttonText || '#ffffff';
    
    return {
      background: `linear-gradient(135deg, ${buttonColor1}, ${buttonColor2})`,
      color: buttonText,
      border: 'none'
    };
  }

  getIconColor() {
    const { qrData } = this.props;
    return qrData?.headerConfig?.iconsColor || '#01315f';
  }

  render() {
    const { t, i18n } = this.props;
    const {
      iva,
      importeBase,
      importeIva,
      total,
      date,
      accessCode,
      downloadingPDF,
      zoneSelected,
      selectedLocker,
      lockerCustomer,
      lockerAssigned,
      lockerInvoice,
      descriptionZone,
      lockerSelected,
      qrToken,
      startDate,
      endDate,
      pinAssigned,
      Ds_MerchantCode,
      Ds_MerchantName,
      Ds_Url,
      Ds_AuthorisationCode,
      Ds_Date,
      Ds_Hour,
      doorAccess,
      customerSocialName,
      customerInvoiceTaxId,
      customerInvoiceAddress,
    } = this.state;

    const buttonStyle = this.getButtonStyle();
    const iconsColor = this.getIconColor();

    if (!lockerAssigned) {
      return (
        <div class="spinner">
          <img src="/images/logo.png" alt="Logo" />
        </div>
      );
    }

    // Helper function to parse DD/MM/YYYY to a Date object in local time
    const parseDate = (dateString) => {
      const [day, month, year] = dateString.split("/"); // Split the string into parts
      return new Date(year, month - 1, day); // Create a Date object in local time (month is 0-indexed)
    };

    // Helper function to format a Date object as YYYY-MM-DD
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-based
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    // Parse startDate and get today's date
    const today = formatDate(new Date());
    const normalizedStartDate = formatDate(parseDate(startDate));

    // Check if the startDate is the same as today's date
    const isStartDateToday = startDate && normalizedStartDate === today;

    console.log(`startDate: ${startDate} / ${today} / ${isStartDateToday}`);

    return (
      <div className="rentalBackground">
        <AppRentalHeader />
        <div className="lockerContainer smartphone">
          <br></br>
          <div className="col flex align-items-center justify-content-center w-25 m-auto">
            <img className="animated-end" src="/images/animated-icons/firecracker.gif" alt="finish" />
          </div>
          <h3 className="lockTitle">
            <span className="text-vw-dark">
              {t("¡GRACIAS POR RESERVAR TU TAQUILLA!")}
            </span>
          </h3>
          <div className="text-vw-semidark text-center">
            {t(
              "Sigue las instrucciones que encontrarás a continuación o en tu email."
            )}
          </div>
          <br></br>

          <div className="unified-form">
            <LockKeyholeOpen className="rental-phoneIcon" strokeWidth={1} style={{ color: iconsColor }} />

            <div className="lockTitle">
              <span className="text-vw-semidark">
                {t("Información de taquilla")}
              </span>
            </div>

            {isStartDateToday ? (
              <>
                <h4 className="lockTitle">
                  <span className="text-vw-light">
                    {t("Nº TAQUILLA")} - {t("PIN")}
                  </span>
                </h4>
                <h3 className="lockTitle flex justify-content-around">
                  {lockerAssigned.split(",").map((matricula, index) => (
                    <span key={index} className="lockLabel">
                      Nº {matricula} - {pinAssigned[index]}
                    </span>
                  ))}
                </h3>
              </>
            ) : (
              <>
                <h4 className="lockTitle">
                  <span className="text-vw-light">{t("Nº TAQUILLA")}</span>
                </h4>
                <h3 className="lockTitle flex justify-content-around">
                  {lockerAssigned.split(",").map((matricula, index) => (
                    <span key={index} className="lockLabel">
                      Nº {matricula}
                    </span>
                  ))}
                </h3>
                <h4 className="lockTitle">
                  <span className="text-vw-light">{t("PIN")}</span>
                </h4>
                <h6 className="lockTitle">
                  <span className="text-vw-dark">
                    {t(
                      "Disponible en tu email que se enviará el día de inicio de tu reserva"
                    )}
                  </span>
                </h6>
              </>
            )}
          </div>

          {doorAccess != 0 && doorAccess != "" && (
            <div className="mt-4 unified-form">
              <DoorOpen className="rental-phoneIcon" strokeWidth={1} style={{ color: iconsColor }} />

              <div className="lockTitle">
                <span className="text-vw-semidark">{t("ACCESO A LOCAL")}</span>
              </div>

              <h3 className="lockTitle flex justify-content-around">
                <span className="lockLabel">C{doorAccess}</span>
              </h3>
            </div>
          )}

          <div className="mt-4 unified-form">
            <FileCheck className="rental-phoneIcon" strokeWidth={1} style={{ color: iconsColor }} />

            <div className="lockTitle">
              <span className="text-vw-semidark">
                {t("Resumen de reserva")}
              </span>
            </div>

            {/* INVOICE */}
            <div className="rental-uf-row no-border">
              <div className="rental-uf-btn">
                <span className="rental-uf-label">
                  {t("Código de reserva")}
                </span>
                <span className="rental-uf-output">{lockerInvoice}</span>
              </div>
            </div>

            {/* ZONE */}
            <div className="mt-2 rental-uf-row no-border">
              <div className="rental-uf-btn">
                <span className="rental-uf-label">{t("Zona")}</span>
                <span className="rental-uf-output">
                  {zoneSelected} - {descriptionZone}
                </span>
              </div>
            </div>

            {/* DATES */}
            <div className="rental-uf-row no-border">
              <div className="d-flex">
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">{t("Inicio")}</span>
                  <span className="rental-uf-output">{startDate}</span>
                </div>
                <vr class="vr"></vr>
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">{t("Fin")}</span>
                  <span className="rental-uf-output">{endDate}</span>
                </div>
              </div>
            </div>
            <div className="rental-uf-row no-border">
              <div className="rental-uf-btn">
                <span className="rental-uf-label">{t("Hora Límite")}</span>
                <span className="rental-uf-output">23:59</span>
              </div>
            </div>

            {/* LOCKER */}
            <div className="rental-uf-row no-border">
              <div className="d-flex">
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">{t("Taquilla")}</span>
                  <span className="rental-uf-output">
                    {this.getLockerType(selectedLocker)}
                  </span>
                </div>
                <vr class="vr"></vr>
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">{t("Cantidad")}</span>
                  <span className="rental-uf-output">
                    {lockerAssigned.split(",").length}
                  </span>
                </div>
              </div>
            </div>

            {/* BASE */}
            <div className="mt-2 rental-uf-row no-border">
              <div className="d-flex">
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">{t("Base")}</span>
                  <span className="rental-uf-output">{importeBase}€</span>
                </div>
                <vr class="vr"></vr>
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">
                    {t("IVA")} ({iva}%)
                  </span>
                  <span className="rental-uf-output">{importeIva}€</span>
                </div>
              </div>
            </div>
            {/* TOTAL */}
            <div className="rental-uf-row no-border">
              <div className="rental-uf-btn">
                <span className="rental-uf-label">{t("Total")}</span>
                <span className="rental-uf-output">{total}€</span>
              </div>
            </div>

            {/* REDSYS */}
            <div className="rental-uf-row no-border">
              <div className="rental-uf-btn">
                <span className="rental-uf-label">{t("Datos Operación")}</span>
                <span className="rental-uf-output">
                  {t("FUC: ")}
                  {Ds_MerchantCode}
                </span>
                <span className="rental-uf-output">
                  {t("COMERCIO: ")}
                  {Ds_MerchantName}
                </span>
                <span className="rental-uf-output">
                  {t("URL: ")}
                  {Ds_Url}
                </span>
                <span className="rental-uf-output">
                  {t("AUTH: ")}
                  {Ds_AuthorisationCode}
                </span>
                <span className="rental-uf-output">
                  {t("FECHA: ")}
                  {Ds_Hour}/{Ds_Date}
                </span>
              </div>
            </div>

            {/* DOWNLOAD PDF */}
            {downloadingPDF ? (
              <div class="spinner">
                <img src="/images/logo.png" alt="Logo" />
              </div>
            ) : (
              <div className="row mt-2 mb-2">
                <div
                  className="col lockerContinueButton"
                  style={buttonStyle}
                  onClick={this.generatePDF}
                >
                  <span>{t("DESCARGAR TICKET")}</span>
                </div>
              </div>
            )}

            {/*
            <div className="row w-100 text-center">
              <div className="mt-5 w-100 text-center">
                <span className="text-vw-semidark rental-phone-advert">
                  {t(
                    "*Si deseas obtener el Pin en formato físico para llevarlo durante tu estancia en el parque contacta con los responsables de la zona de taquillas y enséñales tu email de reserva."
                  )}
                </span>
              </div>
            </div>
            */}
          </div>

          <div className="mt-4 unified-form">
            <ServerCog className="rental-phoneIcon" strokeWidth={1} style={{ color: iconsColor }} />

            <div className="lockTitle">
              <span className="text-vw-semidark">{t("Instrucciones")}</span>
            </div>

            <hr className="bg-vw-dark" />
            <div className="row">
              <div className="col flex align-items-center">
                <img
                  src="/images/lockerBasicClosedStep1.svg"
                  alt="Locker Charger"
                  className="lockerTicketImage"
                />
              </div>
              <div className="col">
                <h5>
                  <span className="rental-uf-label">{t("PASO 1")}</span>
                </h5>
                <h5>
                  <span className="rental-uf-output">
                    {t("LOCALIZA TU TAQUILLA")}
                  </span>
                </h5>
              </div>
            </div>
            <hr className="bg-vw-dark" />
            <div className="row">
              <div className="col">
                <h5>
                  <span className="rental-uf-label">{t("PASO 2")}</span>
                </h5>
                <h5>
                  <span className="rental-uf-output">
                    {t("TOCA EL TECLADO")}
                  </span>
                </h5>
              </div>
              <div className="col flex align-items-center">
                <img
                  src="/images/lockerBasicClosedStep2.svg"
                  alt="Locker Charger"
                  className="lockerTicketImage"
                />
              </div>
            </div>
            <hr className="bg-vw-dark" />
            <div className="row">
              <div className="col flex align-items-center">
                <img
                  src="/images/lockerBasicClosedStep3.svg"
                  alt="Locker Charger"
                  className="lockerTicketImage"
                />
              </div>
              <div className="col">
                <h5>
                  <span className="rental-uf-label">{t("PASO 3")}</span>
                </h5>
                <h5>
                  <span className="rental-uf-output">
                    {t("INTRODUCE TU PIN")}
                  </span>
                </h5>
              </div>
            </div>
            <hr className="bg-vw-dark" />
            <div className="row">
              <div className="col">
                <h5>
                  <span className="rental-uf-label">{t("PASO 4")}</span>
                </h5>
                <h5>
                  <span className="rental-uf-output">
                    {t("ABRE LAS VECES QUE QUIERAS")}
                  </span>
                </h5>
              </div>
              <div className="col flex align-items-center">
                <img
                  src="/images/lockerBasicOpenedStep4.svg"
                  alt="Locker Charger"
                  className="lockerTicketImage"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="lockerContainer pc">
          <div className="col flex align-items-center justify-content-center w-25 m-auto">
            <img
              className="mx-auto d-block animated-end"
              src="/images/animated-icons/firecracker.gif"
              alt="finish"
            />
          </div>
          <h3 className="lockTitle">
            <span className="text-vw-dark">
              {t("¡GRACIAS POR RESERVAR TU TAQUILLA!")}
            </span>
          </h3>
          <div className="lockTitle">
            <span className="text-vw-semidark">
              {t(
                "Sigue las instrucciones que encontrarás a continuación o en tu email."
              )}
            </span>
          </div>
          <div className="mt-4 row">
            <div className="col-4">
              <div className="unified-form">
                <FileCheck className="rental-phoneIcon" strokeWidth={1} style={{ color: iconsColor }} />

                <div className="lockTitle">
                  <span className="text-vw-semidark">
                    {t("Resumen de reserva")}
                  </span>
                </div>

                {/* INVOICE */}
                <div className="rental-uf-row no-border">
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">
                      {t("Código de reserva")}
                    </span>
                    <span className="rental-uf-output">{lockerInvoice}</span>
                  </div>
                </div>

                {/* ZONE */}
                <div className="mt-2 rental-uf-row no-border">
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">{t("Zona")}</span>
                    <span className="rental-uf-output">
                      {zoneSelected} - {descriptionZone}
                    </span>
                  </div>
                </div>

                {/* DATES */}
                <div className="rental-uf-row no-border">
                  <div className="d-flex">
                    <div className="rental-uf-btn">
                      <span className="rental-uf-label">{t("Inicio")}</span>
                      <span className="rental-uf-output">{startDate}</span>
                    </div>
                    <vr class="vr"></vr>
                    <div className="rental-uf-btn">
                      <span className="rental-uf-label">{t("Fin")}</span>
                      <span className="rental-uf-output">{endDate}</span>
                    </div>
                  </div>
                </div>
                <div className="rental-uf-row no-border">
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">{t("Hora Límite")}</span>
                    <span className="rental-uf-output">23:59</span>
                  </div>
                </div>

                {/* LOCKER */}
                <div className="rental-uf-row no-border">
                  <div className="d-flex">
                    <div className="rental-uf-btn">
                      <span className="rental-uf-label">{t("Taquilla")}</span>
                      <span className="rental-uf-output">
                        {this.getLockerType(selectedLocker)}
                      </span>
                    </div>
                    <vr class="vr"></vr>
                    <div className="rental-uf-btn">
                      <span className="rental-uf-label">{t("Cantidad")}</span>
                      <span className="rental-uf-output">
                        {lockerAssigned.split(",").length}
                      </span>
                    </div>
                  </div>
                </div>

                {/* BASE */}
                <div className="mt-2 rental-uf-row no-border">
                  <div className="d-flex">
                    <div className="rental-uf-btn">
                      <span className="rental-uf-label">{t("Base")}</span>
                      <span className="rental-uf-output">{importeBase}€</span>
                    </div>
                    <vr class="vr"></vr>
                    <div className="rental-uf-btn">
                      <span className="rental-uf-label">
                        {t("IVA")} ({iva}%)
                      </span>
                      <span className="rental-uf-output">{importeIva}€</span>
                    </div>
                  </div>
                </div>
                {/* TOTAL */}
                <div className="rental-uf-row no-border">
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">{t("Total")}</span>
                    <span className="rental-uf-output">{total}€</span>
                  </div>
                </div>

                {/* REDSYS */}
                <div className="rental-uf-row no-border">
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">
                      {t("Datos Operación")}
                    </span>
                    <span className="rental-uf-output">
                      {t("FUC: ")}
                      {Ds_MerchantCode}
                    </span>
                    <span className="rental-uf-output">
                      {t("COMERCIO: ")}
                      {Ds_MerchantName}
                    </span>
                    <span className="rental-uf-output">
                      {t("URL: ")}
                      {Ds_Url}
                    </span>
                    <span className="rental-uf-output">
                      {t("AUTH: ")}
                      {Ds_AuthorisationCode}
                    </span>
                    <span className="rental-uf-output">
                      {t("FECHA: ")}
                      {Ds_Hour}/{Ds_Date}
                    </span>
                  </div>
                </div>

                {/* DOWNLOAD PDF */}
                {downloadingPDF ? (
                  <div class="spinner">
                    <img src="/images/logo.png" alt="Logo" />
                  </div>
                ) : (
                  <div className="row mt-2 mb-2">
                    <div
                      className="col lockerContinueButton"
                      style={buttonStyle}
                      onClick={this.generatePDF}
                    >
                      <span>{t("DESCARGAR TICKET")}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-4">
              <div className="unified-form h-auto">
                <LockKeyholeOpen className="rental-phoneIcon" strokeWidth={1} style={{ color: iconsColor }} />

                <div className="lockTitle">
                  <span className="text-vw-semidark">
                    {t("Información de taquilla")}
                  </span>
                </div>

                {isStartDateToday ? (
                  <>
                    <h4 className="lockTitle">
                      <span className="text-vw-light">
                        {t("Nº TAQUILLA")} - {t("PIN")}
                      </span>
                    </h4>
                    <h3 className="lockTitle flex justify-content-around">
                      {lockerAssigned.split(",").map((matricula, index) => (
                        <span key={index} className="lockLabel">
                          Nº {matricula} - {pinAssigned[index]}
                        </span>
                      ))}
                    </h3>
                  </>
                ) : (
                  <>
                    <h4 className="lockTitle">
                      <span className="text-vw-light">{t("Nº TAQUILLA")}</span>
                    </h4>
                    <h3 className="lockTitle flex justify-content-around">
                      {lockerAssigned.split(",").map((matricula, index) => (
                        <span key={index} className="lockLabel">
                          Nº {matricula}
                        </span>
                      ))}
                    </h3>
                    <h4 className="lockTitle">
                      <span className="text-vw-light">{t("PIN")}</span>
                    </h4>
                    <h6 className="lockTitle">
                      <span className="text-vw-dark">
                        {t(
                          "Disponible en tu email que se enviará el día de inicio de tu reserva"
                        )}
                      </span>
                    </h6>
                  </>
                )}

              {/*
                <div className="row w-100 text-center">
                  <div className="mt-5 w-100 text-center">
                    <span className="text-vw-semidark rental-phone-advert">
                      {t(
                        "*Si deseas obtener el Pin en formato físico para llevarlo durante tu estancia en el parque contacta con los responsables de la zona de taquillas y enséñales tu email de reserva."
                      )}
                    </span>
                  </div>
                </div>
              */}
              </div>
              

              {doorAccess != 0 && doorAccess != "" && (
                <div className="mt-4 unified-form h-auto">
                  <DoorOpen className="rental-phoneIcon" strokeWidth={1} style={{ color: iconsColor }} />

                  <div className="lockTitle">
                    <span className="text-vw-semidark">
                      {t("ACCESO A LOCAL")}
                    </span>
                  </div>

                  <h3 className="lockTitle flex justify-content-around">
                    <span className="lockLabel">C{doorAccess}</span>
                  </h3>
                </div>
              )}
            </div>

            <div className="col-4">
              <div className="unified-form h-auto">
                <ServerCog className="rental-phoneIcon" strokeWidth={1} style={{ color: iconsColor }} />

                <div className="lockTitle">
                  <span className="text-vw-semidark">{t("Instrucciones")}</span>
                </div>

                <hr className="bg-vw-dark" />
                <div className="row">
                  <div className="col flex align-items-center">
                    <img
                      src="/images/lockerBasicClosedStep1.svg"
                      alt="Locker Charger"
                      className="lockerTicketImage"
                    />
                  </div>
                  <div className="col">
                    <h5>
                      <span className="rental-uf-label">{t("PASO 1")}</span>
                    </h5>
                    <h5>
                      <span className="rental-uf-output">
                        {t("LOCALIZA TU TAQUILLA")}
                      </span>
                    </h5>
                  </div>
                </div>
                <hr className="bg-vw-dark" />
                <div className="row">
                  <div className="col">
                    <h5>
                      <span className="rental-uf-label">{t("PASO 2")}</span>
                    </h5>
                    <h5>
                      <span className="rental-uf-output">
                        {t("TOCA EL TECLADO")}
                      </span>
                    </h5>
                  </div>
                  <div className="col flex align-items-center">
                    <img
                      src="/images/lockerBasicClosedStep2.svg"
                      alt="Locker Charger"
                      className="lockerTicketImage"
                    />
                  </div>
                </div>
                <hr className="bg-vw-dark" />
                <div className="row">
                  <div className="col flex align-items-center">
                    <img
                      src="/images/lockerBasicClosedStep3.svg"
                      alt="Locker Charger"
                      className="lockerTicketImage"
                    />
                  </div>
                  <div className="col">
                    <h5>
                      <span className="rental-uf-label">{t("PASO 3")}</span>
                    </h5>
                    <h5>
                      <span className="rental-uf-output">
                        {t("INTRODUCE TU PIN")}
                      </span>
                    </h5>
                  </div>
                </div>
                <hr className="bg-vw-dark" />
                <div className="row">
                  <div className="col">
                    <h5>
                      <span className="rental-uf-label">{t("PASO 4")}</span>
                    </h5>
                    <h5>
                      <span className="rental-uf-output">
                        {t("ABRE LAS VECES QUE QUIERAS")}
                      </span>
                    </h5>
                  </div>
                  <div className="col flex align-items-center">
                    <img
                      src="/images/lockerBasicOpenedStep4.svg"
                      alt="Locker Charger"
                      className="lockerTicketImage"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  generatePDF = async () => {
    const {
      iva,
      importeBase,
      importeIva,
      total,
      date,
      accessCode,
      zoneSelected,
      selectedLocker,
      lockerCustomer,
      lockerMatricula,
      lockerAssigned,
      lockerInvoice,
      descriptionZone,
      lockerSelected,
      startDate,
      endDate,
      customerSocialName,
      customerInvoiceTaxId,
      customerInvoiceAddress,
    } = this.state;

    const qrMode = 0; //HARDCODED

    const { t, i18n } = this.props;

    this.setState({ downloadingPDF: true });

    const logocolorDataURL = await this.getImageDataURL(
      "/images/logocolor.png"
    );

    const step1DataURL = await this.getImageDataURL(
      "/images/lockerBasicClosedStep1.png"
    );
    const step2DataURL = await this.getImageDataURL(
      "/images/lockerBasicClosedStep2.png"
    );
    const step3DataURL = await this.getImageDataURL(
      "/images/lockerBasicClosedStep3.png"
    );
    const step4DataURL = await this.getImageDataURL(
      "/images/lockerBasicOpenedStep4.png"
    );

    const step1OTODataURL = await this.getImageDataURL("/images/qr.png");
    const step2OTODataURL = await this.getImageDataURL(
      "/images/lockerOTOStep2.png"
    );
    const step3OTODataURL = await this.getImageDataURL(
      "/images/lockerOpen.png"
    );
    const step4OTODataURL = await this.getImageDataURL(
      "/images/lockerBasicOpenedStep4.png"
    );

    const docDefinition = {
      footer: {
        columns: [
          {
            text: `${t("Más información y garantía en www.vacway.com")}`,
            style: "documentFooterCenter",
          },
        ],
      },
      content: [
        {
          columns: [
            {
              image: logocolorDataURL,
              width: 150,
            },

            [
              {
                text: `${t("TICKET")}`,
                style: "invoiceTitle",
                width: "*",
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: `${t("Reserva")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: `${lockerInvoice}`,
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `${t("Fecha y Hora")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: new Date().toLocaleString(),
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
        "\n\n\n\n",
        {
          columns: [
            {
              text: `${t("INFORMACIÓN DE TU LOCKER:")}`,
              style: "invoiceBillingTitle",
            },
            {
              text: customerSocialName || "VACWAY TECH S.L.",
              style: "invoiceBillingTitle",
            },
          ],
        },
        {
          columns: [
            {
              text: `${t("Nº TAQUILLA")}:  ${lockerAssigned}\n ${t(
                "ZONA"
              )}: ${zoneSelected} - ${descriptionZone} \n ${t(
                "TIPO"
              )}: ${this.getLockerType(selectedLocker)}\n ${t("CANTIDAD")}: ${
                lockerAssigned.split(",").length
              } \n ${t("RESERVA")}: ${startDate} - ${endDate}`,
              style: "invoiceBillingDetails",
            },
            {
              text: `${customerInvoiceAddress || "N/A"} \n CIF: ${customerInvoiceTaxId || "N/A"}`,
              style: "invoiceBillingDetails",
            },
          ],
        },
        "\n\n",
        {
          table: {
            headerRows: 1,
            widths: ["*", 40, "auto", 40, "auto", 80],

            body: [
              [
                {
                  text: `${t("Producto")}`,
                  style: "itemsHeader",
                },
                {
                  text: `${t("UNIDADES")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE BASE")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("TOTAL")}`,
                  style: ["itemsHeader", "center"],
                },
              ],
              [
                [
                  {
                    text: `${this.getLockerType(selectedLocker)}`,
                    style: "itemNumber",
                  },
                ],
                {
                  text: `${lockerAssigned.split(",").length}`,
                  style: "itemNumber",
                },
                {
                  text: `${importeBase}`,
                  style: "itemNumber",
                },
                {
                  text: `${iva}%`,
                  style: "itemNumber",
                },
                {
                  text: `${importeIva}`,
                  style: "itemNumber",
                },
                {
                  text: `${total}`,
                  style: "itemTotal",
                },
              ],
              // END Items
            ],
          },
          layout: "lightHorizontalLines",
        },
        "\n\n\n\n",
        {
          text: `${t("INSTRUCCIONES DE USO:")}`,
          style: "invoiceBillingTitle",
        },
        "\n\n",
        {
          columns: [
            {
              image: step1DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("PASO 1")}\n${t("LOCALIZA TU TAQUILLA")}`,
            },
            {
              image: step2DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("PASO 2")}\n${t("TOCA EL TECLADO")}`,
            },
          ],
        },
        "\n\n\n\n",
        {
          text: ``,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step3DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("PASO 3")}\n${t("INTRODUCE TU PIN")}`,
            },
            {
              image: step4DataURL,
              height: 80,
              width: 120,
            },

            {
              text: `\n${t("PASO 4")}\n${t("ABRE LAS VECES QUE QUIERAS")}`,
            },
          ],
        },
      ],

      styles: {
        // Document Footer
        documentFooterLeft: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "left",
        },
        documentFooterCenter: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "center",
        },
        documentFooterRight: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "right",
        },
        invoiceTitle: {
          fontSize: 22,
          bold: true,
          alignment: "right",
          margin: [0, 0, 0, 15],
        },
        instrucciones: {
          fontSize: 22,
          bold: true,
          alignment: "left",
          margin: [50, 0, 0, 15],
        },
        invoiceSubTitle: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceSubValue: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceBillingTitle: {
          fontSize: 14,
          bold: true,
          alignment: "left",
          margin: [0, 20, 0, 5],
        },
        invoiceBillingDetails: {
          alignment: "left",
          bold: true,
        },
        itemsHeader: {
          margin: [0, 5, 0, 5],
          bold: true,
        },
        itemTitle: {
          bold: true,
        },
        itemNumber: {
          margin: [0, 5, 0, 5],
          alignment: "center",
        },
        itemTotal: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },

        itemsFooterSubTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterSubValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        foto1: {
          alignment: "left",
        },
        itemsFooterTotalTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterTotalValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        signaturePlaceholder: {
          margin: [0, 70, 0, 0],
        },
        signatureName: {
          bold: true,
          alignment: "center",
        },
        signatureJobTitle: {
          italics: true,
          fontSize: 10,
          alignment: "center",
        },
        notesTitle: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 3],
          alignment: "center",
        },
        notesText: {
          fontSize: 10,
        },
        center: {
          alignment: "center",
        },
      },
      defaultStyle: {
        columnGap: 20,
      },
    };

    const docOTODefinition = {
      footer: {
        columns: [
          {
            text: `${t("Más información y garantía en www.vacway.com")}`,
            style: "documentFooterCenter",
          },
        ],
      },
      content: [
        {
          columns: [
            {
              image: logocolorDataURL,
              width: 150,
            },

            [
              {
                text: `${t("TICKET")}`,
                style: "invoiceTitle",
                width: "*",
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: `${t("Factura Simplificada")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: `${lockerInvoice}`,
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `${t("Fecha y Hora")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: new Date().toLocaleString(),
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
        {
          columns: [
            {
              text: `${t("INFORMACIÓN DE TU LOCKER:")}`,
              style: "invoiceBillingTitle",
            },
            {
              text: customerSocialName || "VACWAY WATERPROOF S.L",
              style: "invoiceBillingTitle",
            },
          ],
        },
        {
          columns: [
            {
              text: `${t("Nº TAQUILLA")}:  ${lockerMatricula}\n ${t(
                "CÓDIGO DE ACCESO"
              )}: ${accessCode}\n ${t("ZONA")}: ${zoneSelected} \n ${t(
                "TIPO"
              )}: ${this.getLockerType(lockerSelected)}\n ${t(
                "ACCESIBLE"
              )}:  \n ${t("UBICACIÓN")}: ${lockerCustomer}`,
              style: "invoiceBillingDetails",
            },
            {
              text: `${customerInvoiceAddress || "N/A"} \n CIF: ${customerInvoiceTaxId || "N/A"}`,
              style: "invoiceBillingDetails",
            },
          ],
        },
        "\n\n",
        {
          table: {
            headerRows: 1,
            widths: ["*", 40, "auto", 40, "auto", 80],

            body: [
              [
                {
                  text: `${t("Producto")}`,
                  style: "itemsHeader",
                },
                {
                  text: `${t("UNIDADES")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE BASE")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("TOTAL")}`,
                  style: ["itemsHeader", "center"],
                },
              ],
              [
                [
                  {
                    text: `${this.getLockerType(lockerSelected)}`,
                    style: "itemTitle",
                  },
                ],
                {
                  text: "1",
                  style: "itemNumber",
                },
                {
                  text: `${importeBase}`,
                  style: "itemNumber",
                },
                {
                  text: `${iva}%`,
                  style: "itemNumber",
                },
                {
                  text: `${importeIva}`,
                  style: "itemNumber",
                },
                {
                  text: `${total}`,
                  style: "itemTotal",
                },
              ],
              // END Items
            ],
          },
          layout: "lightHorizontalLines",
        },
        {
          text: `${t("PASO 1")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step1OTODataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t('APRIETA "ABRIR TAQUILLA" O ESCANEA EL QR')}`,
            },
          ],
        },
        {
          text: `${t("PASO 2")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step2OTODataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("ACCEDE CON TUS CREDENCIALES")}`,
            },
          ],
        },
        {
          text: `${t("PASO 3")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step3OTODataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("SELECCIONA ABRIR AHORA")}`,
            },
          ],
        },
        {
          text: `${t("PASO 4")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step4OTODataURL,
              height: 80,
              width: 120,
            },

            {
              text: `\n${t("DISPONES DE 2 APERTURAS")}`,
            },
          ],
        },
      ],

      styles: {
        // Document Footer
        documentFooterLeft: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "left",
        },
        documentFooterCenter: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "center",
        },
        documentFooterRight: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "right",
        },
        invoiceTitle: {
          fontSize: 22,
          bold: true,
          alignment: "right",
          margin: [0, 0, 0, 15],
        },
        instrucciones: {
          fontSize: 22,
          bold: true,
          alignment: "left",
          margin: [0, 0, 0, 15],
        },
        invoiceSubTitle: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceSubValue: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceBillingTitle: {
          fontSize: 14,
          bold: true,
          alignment: "left",
          margin: [0, 20, 0, 5],
        },
        invoiceBillingDetails: {
          alignment: "left",
          bold: true,
        },
        itemsHeader: {
          margin: [0, 5, 0, 5],
          bold: true,
        },
        itemTitle: {
          bold: true,
        },
        itemNumber: {
          margin: [0, 5, 0, 5],
          alignment: "center",
        },
        itemTotal: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },

        itemsFooterSubTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterSubValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        foto1: {
          alignment: "left",
        },
        itemsFooterTotalTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterTotalValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        signaturePlaceholder: {
          margin: [0, 70, 0, 0],
        },
        signatureName: {
          bold: true,
          alignment: "center",
        },
        signatureJobTitle: {
          italics: true,
          fontSize: 10,
          alignment: "center",
        },
        notesTitle: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 3],
          alignment: "center",
        },
        notesText: {
          fontSize: 10,
        },
        center: {
          alignment: "center",
        },
      },
      defaultStyle: {
        columnGap: 20,
      },
    };

    pdfMake
      .createPdf(docDefinition)
      .download(`VACWAYlockers-${lockerInvoice}.pdf`);
    this.setState({ downloadingPDF: false });
  };
}

const mapStateToProps = (state) => ({
  auth: true,
  salerental: state.salerental,
  booking: state.booking,
  qrData: state.qrs.qr,
});

const mapDispatchToProps = (dispatch) => ({
  push: bindActionCreators(push, dispatch),
  postSale: bindActionCreators(postSale, dispatch),
  postRedsysGetParams: bindActionCreators(postRedsysGetParams, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
  putUpdateSale: bindActionCreators(putUpdateSale, dispatch),
  fetchQrByToken: bindActionCreators(fetchQrByToken, dispatch),
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(TicketRentalView)
);
